"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    assertIsArray: function() {
        return assertIsArray;
    },
    assertIsBoolean: function() {
        return assertIsBoolean;
    },
    assertIsDefined: function() {
        return assertIsDefined;
    },
    assertIsInArray: function() {
        return assertIsInArray;
    },
    assertIsInEnum: function() {
        return assertIsInEnum;
    },
    assertIsNonEmptyString: function() {
        return assertIsNonEmptyString;
    },
    assertIsNotDefined: function() {
        return assertIsNotDefined;
    },
    assertIsNumber: function() {
        return assertIsNumber;
    },
    assertIsPlainObject: function() {
        return assertIsPlainObject;
    },
    assertIsString: function() {
        return assertIsString;
    },
    assertIsTrue: function() {
        return assertIsTrue;
    },
    assertIsValidDate: function() {
        return assertIsValidDate;
    },
    assertNever: function() {
        return assertNever;
    },
    assertNeverNoThrow: function() {
        return assertNeverNoThrow;
    },
    enumEntries: function() {
        return enumEntries;
    },
    enumKey: function() {
        return enumKey;
    },
    enumKeys: function() {
        return enumKeys;
    },
    enumValues: function() {
        return enumValues;
    },
    isDefined: function() {
        return isDefined;
    },
    isDefinedAndNonEmpty: function() {
        return isDefinedAndNonEmpty;
    },
    isInEnum: function() {
        return isInEnum;
    },
    isNonEmptyString: function() {
        return isNonEmptyString;
    },
    isNumber: function() {
        return isNumber;
    },
    isNumeric: function() {
        return isNumeric;
    },
    isPlainObject: function() {
        return isPlainObject;
    },
    isValidDate: function() {
        return isValidDate;
    },
    objectEntries: function() {
        return objectEntries;
    },
    objectKeys: function() {
        return objectKeys;
    },
    objectValues: function() {
        return objectValues;
    },
    resolveMaybeFunc: function() {
        return resolveMaybeFunc;
    },
    throwValidationError: function() {
        return throwValidationError;
    },
    toDate: function() {
        return toDate;
    },
    toNumber: function() {
        return toNumber;
    }
});
const _interop_require_default = require("@swc/helpers/_/_interop_require_default");
const _camelCase = /*#__PURE__*/ _interop_require_default._(require("lodash/camelCase"));
const _validationerror = require("../errors/validation.error");
function throwValidationError(error) {
    if (typeof error === 'string') {
        throw new _validationerror.ValidationError(error);
    }
    throw error;
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function assertIsDefined(value, errorMessage) {
    if (!isDefined(value)) {
        throwValidationError(errorMessage || 'The value must be defined and not null.');
    }
}
function assertIsNotDefined(value, errorMessage) {
    if (isDefined(value)) {
        throwValidationError(errorMessage || 'The value must be not defined');
    }
}
function assertIsValidDate(value, errorMessage) {
    if (!(value instanceof Date) || !isValidDate(value)) {
        throwValidationError(errorMessage || 'The value must be a Date object.');
    }
}
function assertIsString(value, errorMessage) {
    if (!(typeof value === 'string')) {
        throwValidationError(errorMessage || 'The value must be a string.');
    }
}
function isNonEmptyString(value) {
    return isDefined(value) && value !== '';
}
function assertIsNonEmptyString(value, errorMessage) {
    errorMessage = errorMessage != null ? errorMessage : 'The value must be a non-empty string';
    assertIsString(value, errorMessage);
    if (!isNonEmptyString(value)) {
        throwValidationError(errorMessage);
    }
}
function isDefinedAndNonEmpty(value) {
    if (typeof value === 'string') {
        return isNonEmptyString(value);
    }
    return isDefined(value);
}
function isNumeric(value) {
    const num = Number(value);
    return isNumber(num);
}
function toNumber(value, errorMessage) {
    const num = Number(value);
    assertIsNumber(num, errorMessage);
    return num;
}
function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
function assertIsNumber(value, errorMessage) {
    if (!isNumber(value)) {
        throwValidationError(errorMessage != null ? errorMessage : 'The value must be a number');
    }
}
function isValidDate(value) {
    return value instanceof Date && !Number.isNaN(value.getTime());
}
function toDate(value, errorMessage) {
    const valueAsDate = new Date(value);
    if (!isValidDate(valueAsDate)) {
        throwValidationError(errorMessage != null ? errorMessage : 'The value is not a valid date/time');
    }
    return valueAsDate;
}
function assertIsInArray(array, value, errorMessage) {
    if (!array.includes(value)) {
        throwValidationError(errorMessage || 'The value is not a member of the array.');
    }
}
function isInEnum(enumValue, value) {
    const values = enumValues(enumValue);
    // The wrapping here is to handle certain mixed types enums
    // and how the values are persisted
    const match = values.some((x)=>typeof x === 'number' ? x === Number(value) : x === String(value));
    return match;
}
function enumKeys(enumValue) {
    const keys = Object.keys(enumValue).filter((key)=>isNaN(Number(key)));
    const set = new Set(keys);
    // this is gross
    // see notes in tsdoc. we are applying a heuristic to filter out possible values
    // if we have some keys that start with a capital (pascalCase),
    // and not all the keys are upper case (screaming snake case)
    // then we will try to filter out possible values from the keys
    if (keys.some((key)=>key[0] === key[0].toUpperCase()) && !keys.every((key)=>key === key.toUpperCase())) {
        keys.forEach((key)=>{
            // assume possible values to be all lower, all upper, including a space, or camelCase keys
            if (key === key.toLowerCase() || key == key.toUpperCase() || key.includes(' ') || key == (0, _camelCase.default)(key)) {
                set.delete(key);
            }
        });
    }
    return [
        ...set
    ];
}
function enumKey(enumValue, value) {
    const keys = enumEntries(enumValue);
    const filtered = keys.filter(([_, v])=>v === value);
    return filtered.length ? filtered[0][0] : undefined;
}
function enumValues(enumValue) {
    const keys = enumKeys(enumValue);
    const values = keys.map((key)=>enumValue[key]);
    return values;
}
function enumEntries(enumValue) {
    const keys = enumKeys(enumValue);
    const values = keys.map((key)=>[
            key,
            enumValue[key]
        ]);
    return values;
}
function assertIsInEnum(enumValue, value, errorMessage) {
    if (!isInEnum(enumValue, value)) {
        if (!errorMessage) {
            let type = typeof value;
            if (type === 'undefined') type = 'value';
            if (type === 'string') value = `'${value}'`;
            const values = enumValues(enumValue).map((x)=>typeof x === 'string' ? `'${x}'` : x).join(', ');
            errorMessage = `The ${type} ${value} is not valid and must be one of ${values}.`;
        }
        throwValidationError(errorMessage);
    }
}
function assertIsBoolean(value, errorMessage) {
    if (typeof value !== 'boolean') {
        throwValidationError(errorMessage != null ? errorMessage : 'The value must be a boolean');
    }
}
function assertIsArray(value, errorMessage) {
    if (!Array.isArray(value)) {
        throwValidationError(errorMessage != null ? errorMessage : 'The value must be an array');
    }
}
function isPlainObject(value) {
    return typeof value === 'object' && value !== null && value.constructor === Object;
}
function assertIsPlainObject(value, errorMessage) {
    if (!isPlainObject(value)) {
        throwValidationError(errorMessage || `The value must be a plain object.`);
    }
}
function assertIsTrue(value, errorMessage) {
    if (!value) {
        throwValidationError(errorMessage || 'The value must be true');
    }
}
function assertNever(value, errorMessage) {
    errorMessage = errorMessage != null ? errorMessage : `Unexpected value: ${String(value)}`;
    if (typeof errorMessage === 'string') {
        throw new _validationerror.ValidationError(errorMessage);
    }
    throw errorMessage;
}
function assertNeverNoThrow(_value) {
/* noop */ }
function objectEntries(t) {
    return Object.entries(t);
}
function objectKeys(t) {
    return Object.keys(t);
}
function objectValues(t) {
    return Object.values(t);
}
function resolveMaybeFunc(input) {
    return typeof input === 'function' ? input() : input;
}

//# sourceMappingURL=validation.js.map